<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  created() {}
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*min-width: 1920px;*/
  /*min-height: 1080px;*/
}

.hiddenImg {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue